// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wxnbU","rightAdornment":"Header_rightAdornment__fIXeT"};